export const icons = {
  search: require('./magnifyingglass.png'),
  microphone: require('./microphone.png'),
  delete: require('./delete.png')
}

export type IconTypes = keyof typeof icons
